import { css } from "@emotion/react";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { IAttachment } from "interfaces/entities/ticket";

import { TicketAttachment } from "./TicketAttachment";

interface ITicketAttachmentsProps {
  hasMessage: boolean;
  attachments: IAttachment[];
  ticketId: string;
}

const ruleStyle = css`
  margin: 15px 0;
  width: 82px;
  height: 1px;
  background: var(${DesignToken.DecorGray100});
`;

export const TicketAttachments: React.FC<ITicketAttachmentsProps> = ({ hasMessage, attachments, ticketId }) => (
  <>
    {hasMessage && <div css={ruleStyle} />}
    Attachments:
    <ul>
      {attachments.map((attachment, idx) => (
        <TicketAttachment key={attachment.url} attachment={attachment} ticketId={ticketId} idx={idx} />
      ))}
    </ul>
  </>
);
